module.exports = __webpack_public_path__ + "static/media/FiraSans-SemiBold.934104ff.ttf";